import { f as filterNumber, c as constructDate, g as getStateAbbreviation } from './helpers.js';

class Owner {
    constructor(owner) {
        this.address = Object.assign({}, new Address(owner.address || {}));
        this.created_at = owner.created_at;
        this.dob_day = filterNumber(owner.dob_day);
        this.dob_month = filterNumber(owner.dob_month);
        this.dob_year = owner.dob_year;
        this.dob_full =
            constructDate(this.dob_year, this.dob_month, this.dob_day) || '';
        this.documents = owner.documents;
        this.email = owner.email;
        this.id = owner.id;
        this.business_id = owner.business_id;
        this.is_owner = owner.is_owner;
        this.metadata = owner.metadata;
        this.name = owner.name;
        this.phone = owner.phone;
        this.platform_account_id = owner.platform_account_id;
        this.identification_number = owner.identification_number;
        this.ssn_last4 = owner.ssn_last4;
        this.title = owner.title;
        this.updated_at = owner.updated_at;
    }
    // Getter method to return the payload in the desired shape
    get payload() {
        return {
            address: new Address(this.address || {}).payload,
            dob_day: this.dob_day || '',
            dob_month: this.dob_month || '',
            dob_year: this.dob_year || '',
            email: this.email || '',
            identification_number: this.identification_number || undefined,
            is_owner: this.is_owner || false,
            metadata: this.metadata || null,
            name: this.name || '',
            phone: this.phone || '',
            platform_account_id: this.platform_account_id || null,
            title: this.title || '',
        };
    }
}
class Representative {
    constructor(representative) {
        this.address = Object.assign({}, new Address(representative.address || {}));
        this.created_at = representative.created_at;
        this.dob_day = filterNumber(representative.dob_day);
        this.dob_month = filterNumber(representative.dob_month);
        this.dob_year = representative.dob_year;
        this.dob_full =
            constructDate(this.dob_year, this.dob_month, this.dob_day) || '';
        this.documents = representative.documents;
        this.email = representative.email;
        this.id = representative.id;
        this.business_id = representative.business_id;
        this.is_owner = representative.is_owner;
        this.metadata = representative.metadata;
        this.name = representative.name;
        this.phone = representative.phone;
        this.platform_account_id = representative.platform_account_id;
        this.identification_number = representative.identification_number;
        this.ssn_last4 = representative.ssn_last4;
        this.title = representative.title;
        this.updated_at = representative.updated_at;
    }
    // Getter method to return the payload in the desired shape
    get payload() {
        return {
            address: new Address(this.address || {}).payload,
            dob_day: this.dob_day || '',
            dob_month: this.dob_month || '',
            dob_year: this.dob_year || '',
            email: this.email || '',
            is_owner: this.is_owner || false,
            identification_number: this.identification_number || undefined,
            metadata: this.metadata || null,
            name: this.name || '',
            phone: this.phone || '',
            platform_account_id: this.platform_account_id || null,
            title: this.title || '',
        };
    }
}

var BusinessFormServerErrors;
(function (BusinessFormServerErrors) {
    BusinessFormServerErrors["fetchData"] = "Error retrieving business data";
    BusinessFormServerErrors["patchData"] = "Error updating business data";
})(BusinessFormServerErrors || (BusinessFormServerErrors = {}));
var BusinessClassification;
(function (BusinessClassification) {
    BusinessClassification["sole_proprietor"] = "sole_proprietor";
    BusinessClassification["partnership"] = "partnership";
    BusinessClassification["corporation"] = "corporation";
    BusinessClassification["public_company"] = "public_company";
    BusinessClassification["limited"] = "limited";
    BusinessClassification["non_profit"] = "non_profit";
    BusinessClassification["government"] = "government";
})(BusinessClassification || (BusinessClassification = {}));
class Address {
    constructor(address) {
        this.id = address.id;
        this.platform_account_id = address.platform_account_id;
        this.line1 = address.line1;
        this.line2 = address.line2;
        this.postal_code = address.postal_code;
        this.city = address.city;
        this.state = getStateAbbreviation(address.state);
        this.country = address.country || 'USA';
        this.created_at = address.created_at;
        this.updated_at = address.updated_at;
    }
    get payload() {
        return {
            platform_account_id: this.platform_account_id || '',
            line1: this.line1 || '',
            line2: this.line2 || '',
            postal_code: this.postal_code || '',
            city: this.city || '',
            state: this.state || '',
            country: this.country || '',
        };
    }
}
class AdditionalQuestions {
    constructor(additionalQuestions) {
        this.business_revenue = additionalQuestions.business_revenue;
        this.business_payment_volume = additionalQuestions.business_payment_volume;
        this.business_when_service_received =
            additionalQuestions.business_when_service_received;
        this.business_recurring_payments =
            additionalQuestions.business_recurring_payments;
        this.business_recurring_payments_percentage =
            additionalQuestions.business_recurring_payments_percentage;
        this.business_seasonal = additionalQuestions.business_seasonal;
        this.business_other_payment_details =
            additionalQuestions.business_other_payment_details;
    }
    get payload() {
        return {
            business_revenue: this.business_revenue || '',
            business_payment_volume: this.business_payment_volume || '',
            business_when_service_received: this.business_when_service_received || '',
            business_recurring_payments: this.business_recurring_payments || '',
            business_recurring_payments_percentage: this.business_recurring_payments_percentage || '',
            business_seasonal: this.business_seasonal || '',
            business_other_payment_details: this.business_other_payment_details || '',
        };
    }
}
class CoreBusinessInfo {
    constructor(coreBusinessInfo) {
        this.classification = coreBusinessInfo.classification;
        this.legal_name = coreBusinessInfo.legal_name;
        this.doing_business_as = coreBusinessInfo.doing_business_as;
        this.industry = coreBusinessInfo.industry;
        this.tax_id = coreBusinessInfo.tax_id;
        this.website_url = coreBusinessInfo.website_url;
        this.email = coreBusinessInfo.email;
        this.phone = coreBusinessInfo.phone;
        this.date_of_incorporation = coreBusinessInfo.date_of_incorporation;
    }
    get payload() {
        return {
            classification: this.classification || '',
            legal_name: this.legal_name || '',
            doing_business_as: this.doing_business_as || '',
            industry: this.industry || '',
            tax_id: this.tax_id || '',
            website_url: this.website_url || '',
            email: this.email || '',
            phone: this.phone || '',
            date_of_incorporation: this.date_of_incorporation || '',
        };
    }
}
class Business {
    constructor(business) {
        this.additional_questions = new AdditionalQuestions(business.additional_questions || {});
        this.associated_accounts = business.associated_accounts;
        this.classification = business.classification;
        this.bank_accounts = business.bank_accounts;
        this.created_at = business.created_at;
        this.documents = business.documents;
        this.doing_business_as = business.doing_business_as;
        this.email = business.email;
        this.id = business.id;
        this.industry = business.industry;
        this.legal_address = new Address(business.legal_address || {});
        this.legal_name = business.legal_name;
        this.metadata = business.metadata;
        this.owners = business.owners;
        this.phone = business.phone;
        this.platform_account_id = business.platform_account_id;
        this.product_categories = business.product_categories;
        this.representative = new Representative(business.representative || {});
        this.tax_id = business.tax_id;
        this.terms_conditions_accepted = business.terms_conditions_accepted;
        this.updated_at = business.updated_at;
        this.website_url = business.website_url;
        this.date_of_incorporation = business.date_of_incorporation;
    }
    get payload() {
        return {
            additional_questions: new AdditionalQuestions(this.additional_questions)
                .payload,
            classification: this.classification || '',
            doing_business_as: this.doing_business_as || '',
            email: this.email || '',
            industry: this.industry || '',
            legal_address: new Address(this.legal_address).payload,
            legal_name: this.legal_name || '',
            metadata: this.metadata || {},
            owners: this.owners.map((owner) => ({ id: owner.id })),
            phone: this.phone || '',
            platform_account_id: this.platform_account_id || '',
            representative: new Representative(this.representative).payload,
            tax_id: this.tax_id || '',
            website_url: this.website_url || '',
            date_of_incorporation: this.date_of_incorporation || '',
        };
    }
}

export { AdditionalQuestions as A, BusinessClassification as B, CoreBusinessInfo as C, Owner as O, Representative as R, Business as a, BusinessFormServerErrors as b, Address as c };
